import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
          {/* About */}
          <article>
            <h4 className="text-lg font-semibold text-gray-900 mb-4 font-serif">
              <a href="#about" className="hover:text-gray-700 transition-colors">Créditos</a>
            </h4>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              A presente reportagem investigativa foi elaborada por Verônica Silva Serpa em cumprimento  parcial do Curso de Jornalismo, do Departamento de Jornalismo, da Faculdade de Arquitetura, Artes, Comunicação e Design (FAAC), da Universidade Estadual Júlio de Mesquita Filho (UNESP), para obtenção do título de Bacharel em Jornalismo, sob a orientação da profa. Associada Maria Cristina Gobbi, 2025. Este levantamento analisa a cobertura jornalística de segurança pública e examina como as narrativas oficiais sobre violência policial são reproduzidas pela mídia brasileira, com foco especial no impacto sobre comunidades negras. 

            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/lastserpa/" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-gray-600 transition-colors" aria-label="Instagram de Verônica Serpa">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a href="https://www.linkedin.com/in/ver%C3%B4nica-serpa/" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-gray-600 transition-colors" aria-label="LinkedIn de Verônica Serpa">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="mailto:v.serpa@unesp.br" className="text-gray-400 hover:text-gray-600 transition-colors" aria-label="Email de contato">
                <i className="ri-mail-fill text-xl"></i>
              </a>
            </div>
          </article>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm">
              © 2025 Verônica Serpa. Todos os direitos reservados.
            </p>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-gray-600 text-sm mt-2 md:mt-0 transition-colors">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
